
import React, { useEffect, useState } from "react";
// import ReactDOM from "react-dom";
// import { Component } from "react";
// import { jsx } from "@emotion/core";
import cn from 'classnames';
import styles from './mychargers.module.scss';
//import Button from "@atlaskit/button";
import Select, { components } from "react-select";

import { defaultTheme } from "react-select";

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = "transparent";
  if (isFocused) bg = "#eee";
  if (isActive) bg = "#B2D4FF";

  const style = {
    alignItems: "center",
    backgroundColor: bg,
    color: "inherit",
    display: "flex ",
    outline: 'none'  
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style
  };

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <label className={cn(styles.customCheckbox)}>

        <input type="checkbox" checked={isSelected} readOnly={true}/>
        <span className={cn(styles.checkmarkDropdown)}></span>
      </label>

      {children}
    </components.Option>
  );
};


const { colors } = defaultTheme;

const selectStyles = {
  // control: (provided) => ({ ...provided, minWidth: '140px', margin: 0 }),
  menu: () => ({ 
    // boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)"
   }),
  control: (base) => ({
    ...base,
    border: '1px solid #ccc',
    boxShadow: 'none',
    minWidth: '140px', margin: 0,
    '&:hover': {
        border: '1px solid #ccc',
    }
})
};

// class App extends Component {
// var state = { isOpen: true, value: undefined };

// var { AppRegistry, StyleSheet, Text, View } = React;

//   var styles = StyleSheet.create({
//     content:{
//         flex:1,
//         flexDirection:'row',
//         alignItems:'center',
//         justifyContent:'center'
//     },
// });

// var stylesbox1 = {
//   border: "3px solid #fff",
//   padding: "0px",
//   minWidth: "440"
// };
///var isopen =true;

// render() {
const ChargerDropDown = (props) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [state, setState] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isCheckAll, setCheckAll] = useState(false);

  var toggleOpen = () => {
    setIsOpen((current) => !current);
  };
  var onSelectChange = (value) => {
    setState(value);
  };

useEffect(()=>{
  if(props?.clickCheck===false || props?.fleetClickCheck===false
    || props?.layoutClickCheck===false || props?.reportClickCheck===false || props?.settingClickCheck===false){
  if(isOpen===true){
    toggleOpen();   
  }
  else {
    setIsOpen(false);
  }
}
},[props?.clickCheck===false, props?.fleetClickCheck===false, props?.layoutClickCheck===false, props?.reportClickCheck===false, props?.settingClickCheck===false])


  
  var stateToSelection = () => {
    setState(null);
    if(selectedOptions!==null){
    setState(selectedOptions?.filter((item) => item.value !== '0'));
    let sitedata=selectedOptions?.filter((item) => item.value !== '0').map((val)=>{
      if(val?.name==='site'){
        return val;
      }
    })
    let chardata=selectedOptions?.filter((item) => item.value !== '0').map((val)=>{
      if(val?.name==='charger'){
        return val;
      }
    })
    let vehicledata=selectedOptions?.filter((item) => item.value !== '0').map((val)=>{
      if(val?.name==='vehicle'){
        return val;
      }
    })
    if(vehicledata[0]?.name==='vehicle'){
      localStorage.setItem('filterVehicle',JSON.stringify(vehicledata))
    }
    if(chardata[0]?.name==='charger'){
      localStorage.setItem('filterCharger',JSON.stringify(chardata))
    }
    if(sitedata[0]?.name==='site'){
      localStorage.setItem('filterSite',JSON.stringify(sitedata))
    }
    props.chargerCallback(selectedOptions?.filter((item) => item.value !== '0'));
    setIsOpen(false)
    }else{
      setIsOpen(false)
    }
    if(selectedOptions===null){
      props?.chargerCallback([]);
      }
    
  };

  var removeSelection = (id) => {
    setCheckAll(false);
    
    setSelectedOptions(selectedOptions?.filter((item) => {
      if (item?.value === '0') {
        selectedOptions.splice(item?.value, 1);
      }
    })); 
    let siteName=selectedOptions?.filter((item) => item.value !== '0').map((val)=>{
      if(val?.name==='site'){
        return val?.name;
      }
    })
    let siteItem=JSON.parse(localStorage.getItem('filterSite'))
    if(siteName[0]==='site'){
      let sitedata=siteItem?.filter((item) => {
        if(item?.name==='site'){
          return  item.value !== id;
        }
      })
    localStorage.setItem('filterSite',JSON.stringify(sitedata))
  }
  let chargerName=selectedOptions?.filter((item) => item.value !== '0').map((val)=>{
    if(val?.name==='charger'){
      return val?.name;
    }
  })
  let chargerItem=JSON.parse(localStorage.getItem('filterCharger'))
  if(chargerName[0]==='charger'){
    let chargerdata=chargerItem?.filter((item) => {
      if(item?.name==='charger'){
        return  item.value !== id;
      }
    })
  localStorage.setItem('filterCharger',JSON.stringify(chargerdata))
 
}
let vehicleName=selectedOptions?.filter((item) => item.value !== '0').map((val)=>{
  if(val?.name==='vehicle'){
    return val?.name;
  }
})
let vehicleItem=JSON.parse(localStorage.getItem('filterVehicle'))
if(vehicleName[0]==='vehicle'){
  let vehicledata=vehicleItem?.filter((item) => {
    if(item?.name==='vehicle'){
      return  item.value !== id;
    }
  })
localStorage.setItem('filterVehicle',JSON.stringify(vehicledata))
}
    setState(state?.filter((item) => item?.value !== id));
    setSelectedOptions(selectedOptions?.filter((item) => item?.value !== id));

    props.chargerCallback(selectedOptions && selectedOptions?.filter((item) => item?.value !== id));
    if (selectedOptions?.length === 2) {
      selectedOptions?.filter((item) => {
        if(item?.value === '0') {
          setSelectedOptions(null);
          props?.chargerCallback([]);
        }
      })
    }
  };

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={toggleOpen}
      target={
        <div className={cn(styles.selectDropdown)}>
          
          <div className={cn(styles.data)} >
            {
              state && state.length > 0
                ? state.map((opt) => {
                  if (opt && opt.value !== "0")
                    return (
                      <div key={opt.value} className={cn(styles.floatChild)}>
                        {opt.label}
                        <span className={cn(styles.btnCross)}
                          key={opt.value}
                          onClick={() => removeSelection(opt.value)}
                        >
                          X
                        </span>
                      </div>
                    );
                })
                : props.text === 'Select' ? 'Select All' : "Select All"}
          </div>
          <button className={cn(styles.dropdownArrow)}
            // style={stylesbox1}
            iconafter={<ChevronDown />}
            onClick={toggleOpen}
            // isSelected={isOpen}
          >
            <img src={require('assets/arrowBottom.svg').default} />
          </button>
        </div>
      }
    >
      <Select
        autoFocus
        backspaceRemovesValue={false}
        defaultValue={[]}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option: InputOption,
          DropdownIndicator,
          IndicatorSeparator: null
        }}
        controlShouldRenderValue={false}
        isClearable={false}
        value={selectedOptions}
        // value={state}
        menuIsOpen
        //onChange={onSelectChange}
        onChange={(options1) => {
          if (Array.isArray(options1)) {
            if(options1.some((item) => 'charger' === item.value)){

            }
            if (options1.some((item) => '0' === item.value)) {
              if (isCheckAll && props.dropdownData.length > options1.length) {
                setCheckAll(false);
                setSelectedOptions(options1?.filter((item) => item.value !== '0'));
              } else if (!isCheckAll) {
                setCheckAll(true);
                setSelectedOptions(props.dropdownData.map((opt) => opt));
              }
            } else {

              if (isCheckAll) {
                // setState(null);
                // props?.chargerCallback([]);
                setCheckAll(false);
                setSelectedOptions(null);
              } else if (props.dropdownData.length === (options1.length + 1)) {
                setSelectedOptions(props.dropdownData.map((opt) => opt));
                setCheckAll(true);
              } else {
                setSelectedOptions(options1.map((opt) => opt));
              }
              // setSelectedOptions(options1.map((opt) => opt));
            }
          }
        }}
        options={props.dropdownData}
        placeholder="Search"
        styles={selectStyles}
        tabSelectsValue={false}
      // value={state.value}
      />
      <button className={cn(styles.btnOk)} onClick={() => stateToSelection()}>OK</button>
    </Dropdown>
  );
};
// }

export default ChargerDropDown;

// styled components

const Menu = (props) => {
  // const shadow = "hsla(218, 50%, 10%, 0.1)";

  return (

    <div className={cn(styles.containerDataSection)}

      {...props}
    />

  );
};
const Blanket = (props) => (
  <div

    {...props}
  />
);
const Dropdown = ({ children, isOpen, target, onClose }) => (
  <div className={cn(styles.mainContainer)}>
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);
const Svg = (p) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);
const DropdownIndicator = () => (
  <div className={cn(styles.colorText)} css={{ color: colors.neutral20, height: 24, width: 32 }}>
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);
const ChevronDown = () => (
  <Svg style={{ marginRight: -6 }}>
    <path
      d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Svg>
);


// const rootElement = document.getElementById("root");
// ReactDOM.render(<App />, rootElement);
